module.exports = "/images/photo-4.jpg?432150b8dee1a108f544b5481c280ac4";